let searchedProducts = null;

export const searchheader = {
    name: 'searchheader',
    component() {
        return {
            products: [],
            queryInput: '',
            minSearchLength: 3,
            isSearching: false,
            lastSearchQuery: '',
            // queryInput: Alpine.$persist([]).as('queryInput'),
            init() {
                window.addEventListener('products-results', (event) => {
                    this.products = event.detail.products;
                });
            },
            subscribe(callback) {
                window.addEventListener('searchrequest-products-complete', callback);
                return () => {
                    window.removeEventListener('searchrequest-products-complete', callback);
                };
            },
            getSearchedProducts() {
                return searchedProducts;
            },
            query(input){
                // Don't search if input is too short or same as last query
                if (input.length < this.minSearchLength || input === this.lastSearchQuery) {
                    // Hide spinner and clear results if input is too short
                    if (input.length < this.minSearchLength) {
                        window.dispatchEvent(new CustomEvent('hide-spinner', {
                            detail: { id: 'spinner-search' }
                        }));
                        // Clear search results when input is too short
                        window.dispatchEvent(new CustomEvent('searchrequest-products-complete', {
                            detail: {
                                query: input,
                                products: [],
                                totalResults: 0,
                                type: 'header'
                            }
                        }));
                    }
                    return;
                }

                this.isSearching = true;
                this.lastSearchQuery = input;

                // Use unified search for all content types
                this.queryInput = input;
                
                window.dispatchEvent(new CustomEvent('show-spinner', {
                    detail: {
                        id: 'spinner-search',
                    },
                }));

                // Single unified search request that handles products, articles, categories, and suggestions
                const unifiedQueryObj = {
                    'query': input,
                    'type': 'header',
                    'index': window.defaultSort || 'default', // Use same default sort
                    'searchOptions': {
                        // This will search all available content types including suggestions and categories
                    }
                }
                
                dispatchEvent(new CustomEvent('searchrequest', { detail: unifiedQueryObj }))
            },
            // Improved debounced search with longer delay for better performance
            debouncedQuery: Alpine.debounce(function(input) {
                this.query(input);
            }, 500), // Increased from 300ms to 500ms
            getQuery(){
                return this.queryInput
            },
            clearInput() {
                this.queryInput = '';
                this.lastSearchQuery = '';
                this.isSearching = false;
                // Clear search results when input is cleared
                window.dispatchEvent(new CustomEvent('searchrequest-products-complete', {
                    detail: {
                        query: '',
                        products: [],
                        totalResults: 0,
                        type: 'header'
                    }
                }));
            },
            shouldShowResults() {
                return this.queryInput.length >= this.minSearchLength;
            }
        }
    }
}

export default searchheader;
